import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const destroyCytoscapeInstance = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.destroy.observe().pipe(
      rxjs.map(({ data }) => {
        manager.destroy(data)
      }),
      rxjs.ignoreElements(),
    ),
)
